import { Card, Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { Button } from '~/components/atoms/Button';

import { IconsMap } from '~/constants/iconsMap';
import { isKeyof } from '~/types';
import type { CardSanityProps } from '~/types/sanity/components';
import { checkAuthVisibility } from '~/utils/auth';
import { buildSanityLinkUrl } from '~/utils/link';

export const CardSanity: FC<Omit<CardSanityProps, '_key' | '_type'>> = ({
  cardColor,
  icon,
  isAuthenticated,
  links,
  paragraph,
  title,
}) => {
  const { name: iconName } = icon ?? {};

  const Icon = isKeyof(IconsMap, iconName) ? IconsMap[iconName] : null;
  const visibleLinks = links ? links.filter((link) => checkAuthVisibility(link.authVisibility, isAuthenticated)) : [];

  return (
    <Card elevation={0} sx={{ backgroundColor: cardColor }}>
      <Stack padding={3} gap={3}>
        {Icon && (
          <Stack
            alignSelf="baseline"
            bgcolor={({ palette }) => palette.background.default}
            borderRadius={({ spacing }) => spacing()}
            flexDirection="row"
            padding={({ spacing }) => spacing(1.5)}
          >
            <Icon fontSize="small" />
          </Stack>
        )}

        {title && <Typography variant="h4">{title}</Typography>}

        <Typography>{paragraph}</Typography>

        {!!visibleLinks?.length && (
          <Stack flexDirection="row" gap={({ spacing }) => spacing(4)}>
            {visibleLinks.map((link, index) => (
              <Button
                data-testid={`card-button-${index}`}
                id={link.id}
                key={link._key}
                to={buildSanityLinkUrl(link)}
                variant="contained"
              >
                {link.label}
              </Button>
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
};
